var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OrganizationDashboardInvitations',{staticClass:"mt-2"}),_c('BaseTitle',{staticClass:"mb-6",domProps:{"textContent":_vm._s(_vm.$tc('organization.collaborator', 2))}}),_c('OrganizationDashboardCollaborators')],1)}
var staticRenderFns = []

export { render, staticRenderFns }